import React from 'react';
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Footer from "./Footer";
import "../styles/Policy.css";
import { Link } from "react-router-dom";

const TermsService = () => {
  return (
    <>
    <div className="terms-service">
      <Container>
        <Row className="justify-content-center">
          <Col md={10} lg={8}>
            <div className="terms-content mt-4 mb-5 p-4">
              <h1 className="text-center mb-4">Terms of Use</h1>
              <p className="version-info text-center mb-4">
                Last updated: March 27, 2025
              </p>
  
              <p>Welcome to Silvertidequest. By using this website and our games, you agree to the following terms. If you do not accept them, please do not use the service.</p>
  
              <h2>🎮 1. About the Service</h2>
              <ul>
                <li>Silvertidequest offers 100% free social casino games.</li>
                <li>There is no option to bet, purchase, or win real money or physical prizes.</li>
                <li>This is not an online casino or gambling service under Nederland law.</li>
                <li>All games are developed solely for entertainment and hold no monetary value.</li>
              </ul>
  
              <h2>🔞 2. Age Restriction</h2>
              <ul>
                <li>The service is only for individuals who are 18 years or older.</li>
                <li>By using the site, you confirm that you are of legal age in your country.</li>
              </ul>
  
              <h2>💳 3. No Money, No Purchases</h2>
              <ul>
                <li>💸 You cannot make deposits</li>
                <li>🛒 There are no payment options</li>
                <li>🎁 You cannot win real money or goods</li>
              </ul>
              <p>Silvertidequest is completely free to use, and no part of the service involves real-money features.</p>
  
              <h2>🧠 4. Responsible Use</h2>
              <p>We encourage all users to play responsibly and in moderation.</p>
              <p>If you experience issues related to gaming, please visit <a href="http://www.loketkansspel.nl" target="_blank" rel="noopener noreferrer">www.loketkansspel.nl</a> – a free and anonymous support service in Netherlands.</p>

              <h2>🔐 5. Privacy & Cookies</h2>
              <p>We use cookies and collect anonymous usage data to improve the service.</p>
              <p>Read more in our <Link to="/privacy-policy">Privacy Policy.</Link></p>
  
              <h2>🔁 6. Changes to the Terms</h2>
              <p>We may update these <Link to="/terms-of-use">terms</Link> without prior notice. By continuing to use the site, you agree to any changes.</p>
  
              <h2>📬 7. Contact</h2>
              <p>Do you have questions about these terms? Contact us:</p>
              <p>Silvertidequest AS</p>
              <p>📍 Assen Drenthe Brink 23, 9401 HT Assen, Netherlands</p>
              <p>📧 Email: Silvertidequest@gmail.com</p>
              <p>📞 Phone: +31 36 533 6736</p>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
    <Footer />
  </>
  
  );
};

export default TermsService;
